// extracted by mini-css-extract-plugin
export default {"main":"Main_main__qHzll","filterBlock":"Main_filterBlock__p+sdB","filterText":"Main_filterText__qJhnV","moreButton":"Main_moreButton__9zzRj","informText":"Main_informText__qfK4g"};